import common from "../../helper/common";

// Constants
export const PROFILE_MENU = {
  id: 116,
  name: "Edit Profile",
  endpoint: "/app/editprofile",
  parentId: null,
  parentname: null,
  action: null,
  children: [],
  controller: null,
  icon: "Graph",
  icontype: 0,
  isActive: true,
  isclubspecific: true,
  isdefaultview: false,
  isdisplayon: false,
  ispremium: false,
  menutab: null,
  menutabid: null,
  premiumallowed: null,
  sortOrder: 1,
  type: 0,
};

export const DEFAULT_ROUTE = "/app/dashboard";
export const NAVIGATION_DELAY = 1000;

/**
 * Helper function to create profile menu with user ID
 */
export const createProfileMenu = (userId) => ({
  ...PROFILE_MENU,
  user: userId,
});

/**
 * Helper function to add profile menu to menus array
 */
export const addProfileMenu = (menus, userId) => {
  if (!menus || menus.length === 0) return menus;
  return [...menus, createProfileMenu(userId)];
};

/**
 * Helper function to update user state (localStorage, global, React)
 */
export const updateUserState = (updatedUser, setUser, currentClubIdRef) => {
  common.setUser(updatedUser);
  global.user = updatedUser;
  global.myClub = updatedUser.myClubs?.find(
    (item) => item.id === updatedUser.defaultClubId
  );
  setUser(updatedUser);
  if (updatedUser.defaultClubId) {
    currentClubIdRef.current = updatedUser.defaultClubId;
  }
};

/**
 * Helper function to get default route from menus
 */
export const getDefaultRoute = (menus) => {
  const defaultMenu = menus?.find((menu) => menu.isdefaultview === true);
  return defaultMenu?.endpoint || DEFAULT_ROUTE;
};

/**
 * Helper function to refresh page after menu update
 */
export const refreshPage = () => {
  window.location.reload();
};

